import { getPf } from "./conf";

const INFO = {
  TRAVITY: {
    phone: "1-646-684-4848",
    email: "service@travity.com",
    partnership: "",
    logo: "../assets/images/icons/logo-travity.svg",
    kakao: "",
    naver: "https://blog.naver.com/tamice",
    instagram: "https://www.instagram.com/with.tamice/",
    favicon: "/travity/favicon.ico",
    title: "Travity",
  },
  DEFAULT: {
    phone: "1-646-684-4848 / 02-336-4480",
    email: "service@tamice.com",
    partnership: "partners@tamice.com",
    logo: "../assets/images/icons/logo.svg",
    kakao: "https://pf.kakao.com/_AAelu/chat",
    naver: "https://blog.naver.com/tamice",
    instagram: "https://www.instagram.com/with.tamice/",
    favicon: "/favicon.ico",
    title: "Tamice",
  },
};

const getInfo = () => (getPf() === "TRAVITY" ? INFO.TRAVITY : INFO.DEFAULT);

export const AppInfo = {
  get: (key: keyof typeof INFO.DEFAULT) => getInfo()[key],
};
